import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session/session.service';
import { TemplatesService } from '../../services/templates/templates.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DeleteTemplateModalComponent } from '../../components/modals/delete-template-modal/delete-template-modal.component';
import { DeleteCategoryModalComponent } from '../../components/modals/delete-category-modal/delete-category-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditCategoryModalComponent } from '../../components/modals/edit-category-modal/edit-category-modal.component';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent implements OnInit {
  public showMenu: any = false;
  public showSideMenu: any = true;
  public allTemplatesType;
  public allTemplatesSubtype;
  public allTemplatesSubtypetemp;
  public allTemplates;
  public seletedtype;
  public userLogged;
  public containerShowing: any = 'subtypes';
  public pagination: any = {
    currentPage: 1,
    pageSize: 5,
    maxSize: 3,
    size: 0,
    limit: 30,
  };
  isAdmin: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private SessionService: SessionService,
    private TemplatesService: TemplatesService,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {
    this.isAdmin = this.SessionService.isAdmin();
  }

  OnPageChange(newPageNumber) {
    this.pagination.currentPage = newPageNumber;
    this.getAllTypeAndTemplate();
  }

  loadMore(){
    this.pagination.limit = this.pagination.limit+30;
    if(this.seletedtype) this.typeselect(this.seletedtype);
    else this.getAllTypeAndTemplate();
  }

  showMenuFn() {
    this.showMenu = !this.showMenu;
  }
  showSideMenuFn() {
    this.showSideMenu = !this.showSideMenu;
  }
  Logout() {
    this.SessionService.logout();
    this.router.navigate(['/']);
  }

  typeselect(id) {
    // if(id == this.seletedtype){
    //   this.seletedtype = 0;
    //   this.allTemplatesSubtype = this.allTemplatesSubtypetemp;
    //   return;
    // }
    if(!this.seletedtype || this.seletedtype!=id)
      this.pagination.limit = 30;
    this.seletedtype = id;
    this.containerShowing = 'subtypes';
    this.TemplatesService.getTypedTemplalates({
      id: id,
      limit: this.pagination.limit,
      offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
    }).then((result) => {
      console.log(result);
      var data = result['data'];
      console.log(data);
      this.pagination.size = parseInt(result['pagination'].count);
      this.pagination.limit = parseInt(result['pagination'].limit);
      this.allTemplatesSubtype = data;
    });
  }

  addCategory(){
    const modalAddReference = this.modalService.open(EditCategoryModalComponent);
    modalAddReference.result
    .then(() => {
      this.loadTemplates();
    })
    .catch(() => {
      this.loadTemplates();
    });
  }

  deleteCategory(id){
    const modalReference = this.modalService.open(DeleteCategoryModalComponent);
    modalReference.componentInstance.typeId = id;
    modalReference.result
    .then(() => {
      this.loadTemplates();
    })
    .catch(() => {
      this.loadTemplates();
    });
  }

  editClick(typeEdit){
    const modalEditReference = this.modalService.open(EditCategoryModalComponent);
    modalEditReference.componentInstance.typeEdit = typeEdit;
    modalEditReference.result
    .then(() => {
      this.loadTemplates();
    })
    .catch(() => {
      this.loadTemplates();
    });
  }

  getAllTypeAndTemplate() {
    this.SpinnerService.show();
    this.TemplatesService.getAllTypeAndTemplate({
      limit: this.pagination.limit,
      offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
    }).then((result) => {
      var data = result['data'];
      console.log(result);
      this.pagination.size = parseInt(result['pagination'].count);
      this.pagination.limit = parseInt(result['pagination'].limit);
      this.allTemplatesType = data.types;
      this.allTemplatesSubtypetemp = data.template;
      this.allTemplatesSubtype = data.template;
      this.SpinnerService.hide();
    });
  }

  deleteTemplate(imageId) {
    const modalRef = this.modalService.open(DeleteTemplateModalComponent);
    modalRef.componentInstance.templateId = imageId;
    modalRef.result
    .then(() => {
      this.loadTemplates();
    })
    .catch(() => {
      this.loadTemplates();
    });
  }

  loadTemplates() {
    this.getAllTypeAndTemplate();
    if (!selectedType)
    var selectedType = this.route.snapshot.paramMap.get('id');
    if (selectedType) this.typeselect(selectedType);
  }
  ngOnInit(): void {
    this.userLogged = this.SessionService.loggedInUser();
    this.loadTemplates();
  }
}
